import React from "react";

const UnderJobContext = React.createContext({ job: null });

export default UnderJobContext;
